export const DOMAINS_LIST_INIT = '[DOMAINS] DOMAINS_LIST_INIT';
export const DOMAINS_LIST_SUCCESS = '[DOMAINS] DOMAINS_LIST_SUCCESS';
export const DOMAINS_LIST_ERROR = '[DOMAINS] DOMAINS_LIST_ERROR';
export const DOMAIN_OPTIONS_BY_TYPE = '[DOMAINS] DOMAINS_LIST_BY_TYPE';
export const DOMAIN_OPTIONS_BY_TYPE_SUCCESS = '[DOMAINS] DOMAINS_LIST_BY_TYPE_SUCCESS';
export const DOMAIN_OPTIONS_BY_TYPE_ERROR = '[DOMAINS] DOMAINS_LIST_BY_TYPE_FAILED';
